module.exports = __webpack_public_path__ + "img/dinamo2.9aed093c.jpg";